const supportedBrowsers = () => ({
  chrome: '>=70',
  firefox: '>=63',
  macos: {
    safari: '>=12',
  },
  edge: '>=17',
  mobile: {
    safari: '>=12',
    'android browser': '>=8',
  },
});

export default supportedBrowsers();
